import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  // Show nothing while checking authentication status
  if (loading) {
    return null; // Or a loading spinner
  }

  if (!isAuthenticated) {
    // Redirect to login page with the return url
    return <Navigate to="/connexion-inscription" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;